/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAssessmentGovernanceCost extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAssessmentGovernanceCost");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAssessmentGovernanceCost.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAssessmentGovernanceCost>): BackgroundJobPayloadForPeriodicAssessmentGovernanceCost {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAssessmentGovernanceCost(), model);
        BackgroundJobPayloadForPeriodicAssessmentGovernanceCost.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAssessmentGovernanceCost>): BackgroundJobPayloadForPeriodicAssessmentGovernanceCost {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAssessmentGovernanceCost.newInstance(<BackgroundJobPayloadForPeriodicAssessmentGovernanceCost> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAssessmentGovernanceCost) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAssessmentGovernanceCost.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAssessmentGovernanceCost): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAssessmentGovernanceCost.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
